import { ApiClient, ApiResponse } from '../client';

export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
}

export class ChatService {
  private client: ApiClient;
  constructor(client: ApiClient) {
    this.client = client;
  }

  public async sendMessage(message: string, history: ChatMessage[] = []): Promise<ApiResponse<{ answer: string; citations: any[] }>> {
    return await this.client.post('/chat', { message, history });
  }

  public async sendFeedback(payload: { message: string; answer: string; citations?: any[]; rating: 'up' | 'down' }): Promise<ApiResponse> {
    return await this.client.post('/chat/feedback', payload);
  }
}


